/* eslint-disable no-nested-ternary */
import { generateAsyncRoute } from '@thd-olt-component-react/router';

const ssr = typeof window === 'undefined';

export const getServerPages = async () => {
  const Components = {};
  if (ssr) {
    Components.localAdPage = (await import(
      './pages/local-ad/LocalAdContainer'
    )).LocalAdContainer;
    Components.home = (await import(
      './pages/Home'
    )).Home;
  }
  return Components;
};

export const getRoutes = (currentRouteName, currentRouteComponent, serverPages) => ({
  localAdPage: {
    name: 'LocalAdContainer',
    componentName: 'LocalAdContainer',
    chunk: () => import(
      './pages/local-ad/LocalAdContainer'
    ),
    get component() {
      return ssr
        ? serverPages.localAdPage
        : currentRouteName === 'LocalAdContainer'
          ? currentRouteComponent
          : generateAsyncRoute(() => this.chunk()
            .then((pageModule) => ({ default: pageModule.LocalAdContainer })));
    },
    path: '/:context?/c/localad'
  },
  home: {
    name: 'home',
    componentName: 'Home',
    chunk: () => import(
      './pages/Home'
    ),
    get component() {
      return ssr
        ? serverPages.home
        : currentRouteName === 'home'
          ? currentRouteComponent
          : generateAsyncRoute(() => this.chunk().then((pageModule) => ({ default: pageModule.Home })));
    },
    path: '/:context?/',
    channel: null
  }
});
